const PROCORE_ALLOWED_EMAIL = "johnwelch@deltek.com";

// Procore is limited to a single user until the integration is released.
export function isProcoreEnabled(email) {
  return (
    typeof email === "string" &&
    email.trim().toLowerCase() === PROCORE_ALLOWED_EMAIL
  );
}
